import { Box, Typography, FormControlLabel, Checkbox, Stack } from '@mui/material';
import { MediaInfoBox } from './MediaInfoBox';

interface ShowLogoOnThumbnailsSectionProps {
  showLogoOnThumbnails: boolean;
  onShowLogoOnThumbnailsChange: (checked: boolean) => void;
}

export function ShowLogoOnThumbnailsSection({
  showLogoOnThumbnails,
  onShowLogoOnThumbnailsChange,
}: ShowLogoOnThumbnailsSectionProps) {
  return (
    <Stack direction="row" spacing={4} sx={{ p: 3 }}>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showLogoOnThumbnails}
              onChange={(e) => onShowLogoOnThumbnailsChange(e.target.checked)}
            />
          }
          label={
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Visa Play-logo på thumbnails
            </Typography>
          }
        />
      </Box>
      <MediaInfoBox>
        Om aktiverad visas Play-logotypen som en overlay på alla video-thumbnails för att tydligt
        markera Play-innehåll.
      </MediaInfoBox>
    </Stack>
  );
}
